// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f6d0c8e8","453":"0494e1d5","732":"dcc80f12"}[chunkId] + ".chunk.js";
};